import { DtoBlocType } from '../../infra/mapper/DtoBlocType'

const blocsToBeSegmented = [
  DtoBlocType.BANNER,
  DtoBlocType.PUSH_PRODUCTS,
  DtoBlocType.RICH_LINK,
  DtoBlocType.HOME_ADVERTORIAL,
]
const blocsWithContentToBeSegmented = [DtoBlocType.CATEGORIES_CONTAINER]

function hasSegmentAllTag(tags: string[]): boolean {
  return tags.some((tag) => tag.match(/^segmentAll$/))
}

function hasSpecificSegmentOrAllSegmentTag(tags: string[], segments: string[]): boolean {
  return tags.some((tag) => segments.includes(tag) || tag.match(/^segmentAll$/))
}

function hasSpecificSegmentTag(tags: string[], segments: string[]): boolean {
  return tags.some((tag) => segments.includes(tag) && !tag.match(/^segmentAll$/))
}

export function filterBlocBySegment(content: any, segmentTags: string[]) {
  if (!content) return null
  const metaTags = content.metadata.tags.map((tag) => tag.sys.id)
  if (!segmentTags.length || segmentTags.every((tag) => tag.match(/^segmentAll$/)))
    return hasSegmentAllTag(metaTags) ? content : null

  return hasSpecificSegmentOrAllSegmentTag(metaTags, segmentTags) ? content : null
}

export function filterBlocContentBySegment(content: any, segmentTags: string[]) {
  if (!content?.fields.items) return null
  const items = content.fields.items.filter((bloc) => filterBlocBySegment(bloc, segmentTags))
  return items.length ? { ...content, fields: { ...content.fields, items } } : null
}

export function filterBlocsBySegment(contents: any, segmentTags: string[]) {
  return contents
    .map((bloc) => {
      if (blocsToBeSegmented.includes(bloc.sys?.contentType?.sys?.id)) return filterBlocBySegment(bloc, segmentTags)
      if (blocsWithContentToBeSegmented.includes(bloc.sys?.contentType?.sys?.id))
        return filterBlocContentBySegment(bloc, segmentTags)
      return bloc
    })
    .filter(Boolean)
}

export function filterNationalHomeBySegment(nationalHome: any, segmentTags: string[]) {
  return {
    ...nationalHome.fields,
    advertorials: nationalHome.fields.advertorials
      ?.map((advertorial) => filterBlocBySegment(advertorial, segmentTags))
      .filter(Boolean),
    banners: nationalHome.fields.banners?.map((banner) => filterBlocBySegment(banner, segmentTags)).filter(Boolean),
    categories: nationalHome.fields.categories
      ?.map((category) => filterBlocBySegment(category, segmentTags))
      .filter(Boolean),
    pushProducts: filterBlocBySegment(nationalHome.fields.pushProducts, segmentTags),
  }
}

export function filterMappedBlocBySegment(content: any, segmentTags: string[]) {
  if (!content) return null
  if (!segmentTags.length) return hasSegmentAllTag(content.tags) ? content : null

  return hasSpecificSegmentOrAllSegmentTag(content.tags, segmentTags) ? content : null
}

export function sortMappedBlocsBySegmentPriority(segments: string[]) {
  return (a, b) => {
    if (hasSpecificSegmentTag(a.tags, segments) && !hasSpecificSegmentTag(b.tags, segments)) return -1
    if (!hasSpecificSegmentTag(a.tags, segments) && hasSpecificSegmentTag(b.tags, segments)) return 1
    if (hasSpecificSegmentTag(a.tags, segments) && hasSpecificSegmentTag(b.tags, segments)) {
      if (a.createdAt < b.createdAt) return 1
      return -1
    }

    return 0
  }
}
